var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"process"},[_c('div',{staticClass:"title"},[_c('p',[_vm._v("轻松"),_c('span',[_vm._v("4")]),_vm._v("步享购")])]),_c('div',{staticClass:"content"},[_c('img',{attrs:{"src":"https://image.suhuishou.com/attached/upload/20220918/20220918225533_5157.png","alt":""}})])])
}]

export { render, staticRenderFns }